import React, { useEffect } from "react";

import { MarkNumbers } from "../../../../models/markNumbers";
import { Input } from "../../../Form";
import { InputProps } from "../../../Form/Input";
import { ControlEditRow, EditMode } from "./types";

type TableRow = MarkNumbers & { editMode: EditMode };

interface EditableFieldTableProps extends InputProps {
  row: TableRow;
  defaultValue?: string;
  parameter: keyof MarkNumbers;
  editedValues: MarkNumbers[];
  handleChangeRowValue: (line: number, newValue: string, parameter: keyof MarkNumbers) => void;
  rowsEditMode?: ControlEditRow;
  placeholderView?: string;
}

export const EditableFieldTable = ({
  row,
  defaultValue,
  parameter,
  editedValues,
  handleChangeRowValue,
  rowsEditMode,
  placeholderView,
  ...inputProps
}: EditableFieldTableProps) => {
  const lineEditMode = rowsEditMode?.[row.line]?.editMode;
  const currentValue = editedValues?.length
    ? editedValues?.find((mark) => mark.line === row.line)?.[parameter]
    : row[parameter];

  useEffect(() => {
    switch (lineEditMode) {
      case EditMode.CANCEL:
        handleChangeRowValue(row.line, defaultValue ?? "", parameter);

        break;
      default:
        break;
    }
  }, [lineEditMode]);

  switch (lineEditMode) {
    case EditMode.EDITING:
    case EditMode.CONFIRM:
      return (
        <Input
          fullWidth
          name="sscc-weight"
          type="text"
          value={currentValue}
          onChange={(event) => handleChangeRowValue(row.line, event.target.value, parameter)}
          {...inputProps}
        />
      );
    default:
      return <div>{defaultValue?.length ? defaultValue : placeholderView}</div>;
  }
};
